import buildItemComponent from "../../common/item-component-hoc"

import CommunityViewFormActionButtonsWidgetContainer from "./view/CommunityViewFormActionButtonsWidgetContainer"
import CommunityViewItemContainer from "./view/CommunityViewItemContainer"
import CommunityFormActionButtonsWidgetContainer from "./edit/CommunityFormActionButtonsWidgetContainer"
import CommunityEditItemContainer from "./edit/CommunityEditItemContainer"

export default buildItemComponent("communities", {
    view: [
        CommunityViewFormActionButtonsWidgetContainer,
        CommunityViewItemContainer
    ],
    edit: [
        CommunityFormActionButtonsWidgetContainer,
        CommunityEditItemContainer
    ]
})
